import Settings from '../components/pages/Settings/Settings'
import MarketSportsList from '../components/pages/MarketSettings/MarketSportsList'
import MarketSettings from '../components/pages/MarketSettings/MarketSettings'
import SoundSchemes from '../components/pages/Settings/SoundSchemes/SoundSchemes'

export default [
  {
    path: '/settings',
    name: 'settings',
    component: Settings,
    children: [
      {
        path: 'sound-notifications',
        name: 'settings.soundNotifications',
        component: SoundSchemes
      }
    ]
  },
  {
    path: '/market-settings',
    name: 'market-settings-list',
    component: MarketSportsList
  },
  {
    path: '/market-settings/:sportId/:tournamentId?',
    name: 'market-settings',
    component: MarketSettings,
    props: true
  }
]
